import { currencyConfig } from '~/config/currencyConfig'
import { createCurrencyAmount } from '~/utils/createCurrencyAmount'

export const CurrencyAmount = createCurrencyAmount(currencyConfig.allowedCurrencies)
